import { getAllCategories } from './getAllCategories'

export const categories = [getAllCategories]
